import { chakra, Grid, GridItem } from '@chakra-ui/react';
import { FC, ReactNode } from 'react';

export const POSTER_HEIGHT = { base: '500px', md: '800px' };

export const HeaderLayout = chakra(Grid, {
  baseStyle: {
    gridTemplateRows: '1fr min-content min-content',
    gridTemplateColumns: '1fr min-content',
    rowGap: '16px',
  },
});

export const HeaderLayoutContent = chakra(GridItem, {
  baseStyle: {
    position: 'relative',
    gridRowStart: '1',
    gridRowEnd: 'auto',
    gridColumnStart: '1',
    gridColumnEnd: 'auto',
  },
});

export const HeaderLayoutSidebar = chakra(GridItem, {
  baseStyle: {
    gridRowStart: { base: '3', md: '1' },
    gridRowEnd: { base: '4', md: '2' },
    gridColumnStart: { base: '1', md: '2' },
    gridColumnEnd: '3',
  },
});

interface IHeaderLayoutOverlayProps {
  isOpen: boolean;
  children: ReactNode;
}

const HeaderLayoutOverlayBase = {
  position: 'relative',
  gridRow: '1 / 2',
  gridColumn: '1 / 3',
};

export const HeaderLayoutOverlay: FC<IHeaderLayoutOverlayProps> = ({ isOpen, children }) => {
  const HeaderLayoutOverlayStyles = { ...HeaderLayoutOverlayBase, height: isOpen ? POSTER_HEIGHT : null };

  return <GridItem sx={HeaderLayoutOverlayStyles}>{children}</GridItem>;
};
